import { render, staticRenderFns } from "./VesselMonitoringFullBay.vue?vue&type=template&id=6d67d0ed&scoped=true"
import script from "./VesselMonitoringFullBay.vue?vue&type=script&lang=ts"
export * from "./VesselMonitoringFullBay.vue?vue&type=script&lang=ts"
import style0 from "./VesselMonitoringFullBay.vue?vue&type=style&index=0&id=6d67d0ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d67d0ed",
  null
  
)

export default component.exports